<section>
  <article>
    <h1 class="deprecated-logo">Twona</h1>
    <div class="deprecated-alert">
      You are using an ancient browser. We are not archaeologists... but we can take you to <a target="_blank" href="https://www.google.com/chrome/">the future</a>.
    </div>
  </article>
</section>
